import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StackService<T> {
  private stack: T[] = []; // Internal stack storage
  private stack$ = new BehaviorSubject<T[]>([]); // Observable source for stack changes

  // Observable that components can subscribe to
  stackObservable = this.stack$.asObservable();

  // Add a new item to the stack
  push(item: T) {
    this.stack.push(item);
    this.stack$.next([...this.stack]); // Emit updated stack
  }

  // Remove the last item from the stack (go back)
  pop(): T | undefined {
    const removed = this.stack.pop();
    this.stack$.next([...this.stack]); // Emit updated stack
    return removed;
  }

  // Get the current (top) item
  current(): T | undefined {
    return this.stack[this.stack.length - 1];
  }

  // Update the last (current) item in the stack
  updateCurrent(updater: (item: T) => T) {
    if (this.stack.length === 0) return; // Nothing to update
    const lastIndex = this.stack.length - 1;
    this.stack[lastIndex] = updater(this.stack[lastIndex]); // Replace with updated version
    this.stack$.next([...this.stack]); // Emit updated stack
  }

  // Reset the stack completely
  reset() {
    this.stack = [];
    this.stack$.next([]);
  }

  // Get all items in the stack
  getAll(): T[] {
    return [...this.stack];
  }
}
